import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { useSwiper } from 'swiper/react';
import "swiper/css";
import 'swiper/css/pagination';
import { Pagination, Navigation } from 'swiper/modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestion, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { isAndroid, isIOS } from 'react-device-detect';

const HelpView = ({ setPage, canReset, userSelections, setUserSelections }) => {
    const NextSlideButton = () => {
        const swiper = useSwiper();
        return (
            <button onClick={() => swiper.slideNext()} className="btn" style={{ flex: .99 }}>
                Next
            </button>
        );
    };

    return (
        <div className="modal">
            <div id="helpContent"            >
                <div id="helpContentText">
                    <h1>EDCO26 Planner</h1>

                    <Swiper navigation={true} pagination={true} modules={[Pagination, Navigation]} className="mySwiper">
                        <SwiperSlide>
                            <h2>Highlight your festival choices</h2>
                            <p>
                                Toggle between "Must Sees" <FontAwesomeIcon icon={faThumbsUp} /> and "Maybes" <FontAwesomeIcon icon={faQuestion} /> <br />
                                then tap an artist's set to highlight. <br />
                                Be sure to view all three days!<br />

                            </p>
                            <div className="button-container">
                                <NextSlideButton />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <h2>Add your personalized QR code</h2>
                            <p>Select a social network or add a custom URL.<br />
                                Scan and connect with new friends!<br />
                                Can also help identify the device owner if lost.
                            </p>
                            <img src="/helpQrCodes.png" width="300" alt="Create a Personalized QR Code" />
                            <div className="button-container">
                                <NextSlideButton />
                            </div>
                        </SwiperSlide>
                        {(isIOS || isAndroid) && <SwiperSlide>
                            <h2>Add as a Home Page App</h2>
                            <p>Create a home screen shortcut
                                for quick access.<br />
                            </p>
                            {isIOS && <>
                                <h4>1. Tap the Share icon <br />(square with arrow)</h4>
                                <h4>2. Tap Add to Home Screen</h4>
                            </>}
                            {isAndroid && <>
                                <h4>1. Tap the ⋮ menu (top-right)</h4>
                                <h4>2. Tap Add to Home Screen</h4>
                            </>}
                            <div className="button-container">
                                <NextSlideButton />
                            </div>
                        </SwiperSlide>}
                        <SwiperSlide>
                            <h2>Download Device Wallpaper</h2>
                            <p>Select <strong>Create Wallpaper</strong><br />to generate images for each day.<br />
                                Follow device instructions to set up wallpaper,<br />
                                you can also post to social and share with friends!</p>
                            <h2 style={{ marginTop: '40px' }}>Never Lose Access</h2>
                            <p>Log in with your Google Account and save across devices!</p>
                            <div className="button-container">
                                <NextSlideButton />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <h2>Join Groups with Friends</h2>
                            <p>1. Log in with your Google Account</p>
                            <p>2. Tap <strong>Create Group</strong> and share<br />
                                the 8-digit code with friends </p>
                            <p>3. Tap <strong>Join Group</strong> and enter<br />
                                the 8-digit code shared with you</p>
                            <p>4. Return to schedule view to see indicators<br />
                                of how many friends are interested in a set</p>
                            <p>5. Turn off the "Must Sees" and "Maybes" toggles, <br />
                                then tap a set to view which friends are interested</p>
                            <div className="button-container">
                                <button onClick={() => {
                                    setPage('calendar');
                                    localStorage.setItem('page', 'calendar');
                                }
                                }
                                    className="btn" style={{ flex: .99 }}>
                                    Let's Go!
                                </button>
                            </div>
                        </SwiperSlide>
                    </Swiper>

                    {/* <blockquote>Test Data Currently In Use</blockquote> */}


                    <h6>Images and schedule data are <br />© Insomniac Events, Inc. All rights reserved. <br />
                        The EDCO26 Planner is an unofficial app <br />created by <a target="_blank" rel="noreferrer" href="https://linktr.ee/skydivingjeff">Jeff P</a> at <a target="_blank" rel="noreferrer" href="https://sunsetskycreative.com">Sunset Sky Creative</a></h6>
                    <h6>This app is ad-free & made with ❤️ <br /> <a rel="noreferrer" href="https://cash.app/skydivingjeff">please consider tipping a small thank-you</a></h6>
                    {canReset && <div className="button-container">
                        <button onClick={() => {
                            const newSelections = {
                                ...userSelections,
                                selections: []
                            }
                            setUserSelections(newSelections)
                            localStorage.setItem('savedSelections', JSON.stringify(newSelections));
                        }
                        }
                            className="btn btn-danger">
                            Clear All Selections
                        </button>
                    </div>}
                </div>
            </div>
        </div>
    )
}

export default HelpView;